<template>
  <v-app>
    <RouterView></RouterView>
  </v-app>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { RouterView } from "vue-router"
import { useTheme } from 'vuetify'
import { useThemeStore } from '@/stores/theme'

const theme = useTheme()
const themeStore = useThemeStore()

onMounted(() => {
  themeStore.initializeTheme()
  themeStore.applyTheme(theme)
})
</script>

<style lang="scss">

body {
  top: 0 !important;
  position: static !important;
}

.skiptranslate,
.goog-te-banner-frame,
iframe.goog-te-banner-frame,
.goog-te-balloon-frame,
div#goog-gt-tt {
  display: none !important;
  visibility: hidden !important;
}

body.translated-ltr,
body.translated-rtl {
  margin-top: 0 !important;
}
</style>